module.exports = __webpack_public_path__ + "img/news_list_6.eb8b03d7.jpg";